import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import FooterBase from "./FooterBase";
import FooterMobile from "./FooterMobile";

const Footer = () => {

	const { isMobile } = useSelector(state => state.general);

    return (

        <Routes>
            <Route  path='/' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/checkout/cart' element={ isMobile ? <FooterMobile data={{showCart: true}} /> : <FooterBase />} />
            <Route  path='/profile/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : null} />
            <Route  path='/category/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/seller/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/best-selling' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/best-selling/*' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/amazing-offers' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
            <Route  path='/flash-sale' element={ isMobile ? <FooterMobile data={{showCart: false}} /> : <FooterBase />} />
        </Routes>

    );
}

export default Footer;